import { difference, isUndefined } from 'lodash';
import type { Question } from 'schema/poll';
import { selectCorrectIds } from './selectCorrectIds';
import { selectCorrectRanks } from './selectCorrectRanks';

export function isAnswersCorrect(question: Question, answeredIds: string[], answeredOthers: string | undefined) {
  if (question.data.type === 'POLL_TEXTAREA') {
    if (!answeredOthers) return false;

    const textareaType = 'textareaType' in question.data ? question.data.textareaType : 'TEXT';
    const successAnswer = 'successAnswer' in question.data ? question.data.successAnswer : undefined;
    const successNumber = 'successNumber' in question.data ? question.data.successNumber : undefined;

    if (textareaType === 'NUMBER' && !isUndefined(successNumber)) {
      const correctSuccessNumber = successNumber.toString().replace(/[,.]/g, ',');
      const correctAnsweredOthers = answeredOthers.replace(/[,.]/g, ',');
      return correctSuccessNumber === correctAnsweredOthers;
    }

    if (['TEXT', 'SINGLE_LINE_TEXT', 'SINGLE_LINES_TEXT'].includes(textareaType) && !isUndefined(successAnswer)) {
      return successAnswer.toLowerCase().trim() === answeredOthers.toLowerCase().trim();
    }

    return false;
  }

  if (question.data.type === 'POLL_RANK') {
    const correctRanks = new Map<string, number>(selectCorrectRanks(question));
    answeredIds = answeredIds.filter(id => correctRanks.has(id));

    if (answeredIds.length !== correctRanks.size) return false;
    return answeredIds.every((id, index) => correctRanks.get(id) === index + 1);
  }

  const correctIds = selectCorrectIds(question);
  return difference(correctIds, answeredIds).length === 0 && difference(answeredIds, correctIds).length === 0;
}
